/* eslint-disable indent */
/* eslint-disable @typescript-eslint/camelcase */
import { batchRequests } from 'apis';
import i18n from 'i18n';
import { messagesRequest } from 'modules/messages/actions';
import { modalClose } from 'modules/modal/actions';
import { push } from 'react-router-redux';
import {
  all,
  call,
  put,
  takeLatest,
  select,
  takeEvery,
} from 'redux-saga/effects';
import { isRequestOK } from 'utils/helpers';
import { BatchRequest, removePayloadKeys } from 'utils/tsHelpers';
import { selectCompany, selectPartner } from 'modules/authenticate/actions';
import { getAllPartnerServersRequest } from 'modules/partners/actions';
import { AxiosResponse } from 'axios';
import { MaintenanceDisplay } from 'containers/Clients/MaintenanceClients/DisplayForm';
import { BlockInstancesFormDisplay } from 'containers/Environments/MaintenanceEnvironments/BlockInstances/BlockInstancesForm';
import { RemoveSessionsFormDisplay } from 'containers/Environments/MaintenanceEnvironments/RemoveSessions/RemoveSessionsForm';
import { getEditModelErrorMessageKey } from './modelErrorMessages';
import {
  activateInstanceFulfilled,
  activateInstanceRejected,
  activateInstanceRequest,
  connectAsFulfilled,
  connectAsRejected,
  connectAsRequest,
  duplicateModelFulfilled,
  duplicateModelRejected,
  duplicateModelRequest,
  editEnvironmentBehaviorFulfilled,
  editEnvironmentBehaviorRejected,
  editEnvironmentBehaviorRequest,
  editEnvironmentsFulfilled,
  editEnvironmentsRejected,
  editEnvironmentsRequest,
  editMaintenanceEnvironmentsFulfilled,
  editMaintenanceEnvironmentsRejected,
  editMaintenanceEnvironmentsRequest,
  editModelFulfilled,
  editModelRejected,
  editModelRequest,
  editSecurityFulfilled,
  editSecurityRejected,
  editSecurityRequest,
  getAlarmsInstanceFulfilled,
  getAlarmsInstanceRejected,
  getAlarmsInstanceRequest,
  getAllEnvironmentsFulfilled,
  getAllEnvironmentsRejected,
  getAllEnvironmentsRequest,
  getAllImagesLogsFulfilled,
  getAllImagesLogsRejected,
  getAllImagesLogsRequest,
  getAllInstancesFulfilled,
  getAllInstancesRejected,
  getAllInstancesRequest,
  getAllModelsFulfilled,
  getAllModelsRejected,
  getAllModelsRequest,
  getAllServersFulfilled,
  getAllServersRejected,
  getAllServersRequest,
  getAllSessionsInInstanceFulfilled,
  getAllSessionsInInstanceRejected,
  getAllSessionsInInstanceRequest,
  getInstanceObservabilityFulfilled,
  getInstanceObservabilityRejected,
  getInstanceObservabilityRequest,
  getEnvironmentBehaviorFulfilled,
  getEnvironmentBehaviorRejected,
  getEnvironmentBehaviorRequest,
  getEnvironmentFulfilled,
  getEnvironmentRejected,
  getEnvironmentRequest,
  getInstanceChartDashboardFulfilled,
  getInstanceChartDashboardRejected,
  getInstanceChartDashboardRequest,
  getMaintenanceFulfilled,
  getMaintenanceRejected,
  getMaintenanceRequest,
  getModelFulfilled,
  getModelRejected,
  getModelRequest,
  getProviderResourcesFulfilled,
  getProviderResourcesRejected,
  getProviderResourcesRequest,
  getSecurityStateFulfilled,
  getSecurityStateRejected,
  getSecurityStateRequest,
  getSessionsChartDashboardFulfilled,
  getSessionsChartDashboardRejected,
  getSessionsChartDashboardRequest,
  getUrlsEnvironmentsDashboardFulfilled,
  getUrlsEnvironmentsDashboardRejected,
  getUrlsEnvironmentsDashboardRequest,
  newEnvironmentFulfilled,
  newEnvironmentRequest,
  rebootInstanceFulfilled,
  rebootInstanceRejected,
  rebootInstanceRequest,
  registerModelFulfilled,
  registerModelRejected,
  registerModelRequest,
  registerNewInstanceFulfilled,
  registerNewInstanceRejected,
  registerNewInstanceRequest,
  removeEnvironmentFulfilled,
  removeEnvironmentRejected,
  removeEnvironmentRequest,
  removeInstanceFulfilled,
  removeInstanceRejected,
  removeInstanceRequest,
  removeModelFulfilled,
  removeModelRejected,
  removeModelRequest,
  removeMultipleModelsFulfilled,
  removeMultipleModelsRejected,
  removeMultipleModelsRequest,
  removeSessionsInstanceFulfilled,
  removeSessionsInstanceRejected,
  removeSessionsInstanceRequest,
  restartServerFulfilled,
  restartServerRejected,
  restartServerRequest,
  stopServerFulfilled,
  stopServerRejected,
  stopServerRequest,
  startServerFulfilled,
  startServerRejected,
  startServerRequest,
  terminateInstanceFulfilled,
  terminateInstanceRejected,
  terminateInstanceRequest,
  terminateMultipleInstancesFulfilled,
  terminateMultipleInstancesRejected,
  terminateMultipleInstancesRequest,
  toggleBlockInstancesFulfilled,
  toggleBlockInstancesRejected,
  toggleBlockInstancesRequest,
  unlinkInstanceFulfilled,
  unlinkInstanceRejected,
  unlinkInstanceRequest,
  toggleBlockMultipleInstancesFulfilled,
  toggleBlockMultipleInstancesRejected,
  toggleBlockMultipleInstancesRequest,
  getAllEnvironmentsOperatorRequest,
  getAllEnvironmentsOperatorFulfilled,
  getAllEnvironmentsOperatorRejected,
  getDashboardSessionsGraphRequest,
  getDashboardSessionsGraphFulfilled,
  getDashboardSessionsGraphRejected,
  getBootVolumesRequest,
  getBootVolumesFulFilled,
  getBootVolumesRejected,
  getSecurityGroupsRequest,
  getSecurityGroupsRejected,
  getSecurityGroupsFulFilled,
  getZonesFulFilled,
  getZonesRejected,
  getZonesRequest,
  getSubnetsFulFilled,
  getSubnetsRejected,
  getKeyPairsFulFilled,
  getKeyPairsRejected,
  getSubnetsRequest,
  getKeyPairsRequest,
  getListProviderResourcesFulFilled,
  getListProviderResourcesRejected,
  getListProviderResourcesRequest,
  getAwsResourcesRequest,
  getImagesFulFilled,
  getImagesRejected,
  getImagesRequest,
  getFlavorsRequest,
  getFlavorsFulFilled,
  getFlavorsRejected,
  getOciResourcesRequest,
  getBootVolumeBackupsRequest,
  getBootVolumeBackupsFulFilled,
  getBootVolumeBackupsRejected,
  getDashboardEnvironmentCostGraphRequest,
  getDashboardEnvironmentCostGraphFulfilled,
  getDashboardEnvironmentCostGraphRejected,
  getFlavorsCostRequest,
  getFlavorsCostFulfilled,
  getFlavorsCostRejected,
  getAllApplicationsAutoskyFulfilled,
  getAllApplicationsAutoskyRejected,
  getAllApplicationsAutoskyRequest,
  getClientsApplicationsAutoskyFulfilled,
  getClientsApplicationsAutoskyRejected,
  getClientsApplicationsAutoskyRequest,
  renameClientsApplicationsAutoskyFulfilled,
  renameClientsApplicationsAutoskyRejected,
  renameClientsApplicationsAutoskyRequest,
  removeClientsApplicationsAutoskyFulfilled,
  removeClientsApplicationsAutoskyRejected,
  removeClientsApplicationsAutoskyRequest,
  changeStateClientsApplicationsAutoskyFulfilled,
  changeStateClientsApplicationsAutoskyRejected,
  changeStateClientsApplicationsAutoskyRequest,
  includeClientsApplicationsAutoskyFulfilled,
  includeClientsApplicationsAutoskyRejected,
  includeClientsApplicationsAutoskyRequest,
  getClientsToIncludeApplicationsAutoskyFulfilled,
  getClientsToIncludeApplicationsAutoskyRejected,
  getClientsToIncludeApplicationsAutoskyRequest,
  getAllApplicationsPlatformFulfilled,
  getAllApplicationsPlatformRejected,
  getAllApplicationsPlatformRequest,
  getClientsApplicationsPlatformFulfilled,
  getClientsApplicationsPlatformRejected,
  getClientsApplicationsPlatformRequest,
  removeClientsApplicationsPlatformFulfilled,
  removeClientsApplicationsPlatformRejected,
  removeClientsApplicationsPlatformRequest,
  migrateEnvironmentFulfilled,
  migrateEnvironmentRejected,
  migrateEnvironmentRequest,
  setMigrateErrors,
  stopTimeRejected,
  stopTimeFulfilled,
  stopTimeRequest,
  publishNewImageRejected,
  publishNewImageRequest,
  publishNewImageFulfilled,
  getEnvironmentMonitoringFulfilled,
  getEnvironmentMonitoringRequest,
  getEnvironmentMonitoringRejected,
  editEnvironmentMonitoringFulfilled,
  editEnvironmentMonitoringRejected,
  editEnvironmentMonitoringRequest,
  getMonitoringHistoryFulfilled,
  getMonitoringHistoryRejected,
  getMonitoringHistoryRequest,
  attachServerFulfilled,
  attachServerRejected,
  attachServerRequest,
  detachServerRejected,
  detachServerFulfilled,
  detachServerRequest,
  getEnvironmentPerformanceCPUFulfilled,
  getEnvironmentPerformanceCPURejected,
  getEnvironmentPerformanceCPURequest,
  getEnvironmentPerformanceMemoryFulfilled,
  getEnvironmentPerformanceMemoryRejected,
  getEnvironmentPerformanceMemoryRequest,
  getPreparationServerFulfilled,
  getPreparationServerRejected,
  getPreparationServerRequest,
  getSupportServerFulfilled,
  getSupportServerRejected,
  getSupportServerRequest,
  getEnvironmentPerformanceOperationalTimeFulfilled,
  getEnvironmentPerformanceOperationalTimeRejected,
  getEnvironmentPerformanceOperationalTimeRequest,
  getPublicationScheduleFulfilled,
  getPublicationScheduleRejected,
  getPublicationScheduleRequest,
  setPublicationScheduleFulfilled,
  setPublicationScheduleRejected,
  setPublicationScheduleRequest,
  cancelPublicationScheduleFulfilled,
  cancelPublicationScheduleRejected,
  cancelPublicationScheduleRequest,
  getBulkClientsRequest,
  getBulkClientsRejected,
  getBulkClientsFulfilled,
  editBulkClientsFulfilled,
  editBulkClientsRejected,
  editBulkClientsRequest,
  setProductionEnvironmentRequest,
  acceptStatusPendingRequest,
  acceptStatusPendingFulfilled,
  acceptStatusPendingRejected,
  getStatusReportFulfilled,
  getStatusReportRejected,
  getStatusReportRequest,
  getTimezonesFulfilled,
  getTimezonesRejected,
  getTimezonesRequest,
  extendCompletionDateFulfilled,
  extendCompletionDateRejected,
  extendCompletionDateRequest,
  getProductReportFulfilled,
  getProductReportRejected,
  getProductReportRequest,
  getBehaviorReportFulfilled,
  getBehaviorReportRejected,
  getBehaviorReportRequest,
  getRegionReportFulfilled,
  getRegionReportRejected,
  getRegionReportRequest,
  getZeroTrustReportFulfilled,
  getZeroTrustReportRejected,
  getZeroTrustReportRequest,
  getMaintenanceReportFulfilled,
  getMaintenanceReportRejected,
  getMaintenanceReportRequest,
  getVirtualizerReportFulfilled,
  getVirtualizerReportRejected,
  getVirtualizerReportRequest,
  getProviderReportFulfilled,
  getProviderReportRejected,
  getProviderReportRequest,
  getDNSReportFulfilled,
  getDNSReportRejected,
  getDNSReportRequest,
  exportEnvironmentSummaryFulfilled,
  exportEnvironmentSummaryRejected,
  exportEnvironmentSummaryRequest,
  validateZeroTrustFulfilled,
  validateZeroTrustRejected,
  validateZeroTrustRequest,
  publishImageFulfilled,
  publishImageRejected,
  publishImageRequest,
  getPublishHistoryRequest,
  getPublishHistoryFulfilled,
  getPublishHistoryRejected,
  exportHistoryMonitoringCSVRejected,
  exportHistoryMonitoringCSVRequest,
  blockServerActionsRequest,
  blockServerActionsFulfilled,
  blockServerActionsRejected,
  unblockServerActionsFulfilled,
  unblockServerActionsRejected,
  unblockServerActionsRequest,
  getEnvironmentSessionsFulfilled,
  getEnvironmentSessionsRejected,
  getEnvironmentSessionsRequest,
  getProductTypeReportRequest,
  getProductTypeReportFulfilled,
  getProductTypeReportRejected,
  exportHistoryMonitoringCSVFulfilled,
  getLicenseGroupsRequest,
  getLicenseGroupsFulfilled,
  getLicenseGroupsRejected,
  createLicenseGroupFulfilled,
  createLicenseGroupRejected,
  createLicenseGroupRequest,
  getLicenseGroupDetailsFulfilled,
  getLicenseGroupDetailsRejected,
  getLicenseGroupDetailsRequest,
  addClientsToLicenseGroupRequest,
  deleteLicenseGroupRequest,
  fullUpdateLicenseGroupClientsRequest,
  editLicenseGroupRequest,
  addClientsToLicenseGroupFulfilled,
  addClientsToLicenseGroupRejected,
  fullUpdateLicenseGroupClientsFulfilled,
  fullUpdateLicenseGroupClientsRejected,
  editLicenseGroupFulfilled,
  editLicenseGroupRejected,
  deleteLicenseGroupFulfilled,
  deleteLicenseGroupRejected,
  getConnectionTypeEnvironmentReportFulfilled,
  getConnectionTypeEnvironmentReportRejected,
  getConnectionTypeEnvironmentReportRequest,
  getEnvironmentAdvisorsRequest,
  getEnvironmentAdvisorsFulfilled,
  getEnvironmentAdvisorsRejected,
  getAdminPinRequest,
  getAdminPinFulfilled,
  getAdminPinRejected,
  resetAdminPinFulfilled,
  resetAdminPinRejected,
  resetAdminPinRequest,
  enableServerMonitoringManagementRequest,
  enableServerMonitoringManagementRejected,
  enableServerMonitoringManagementFulfilled,
  disableServerMonitoringManagementRequest,
  disableServerMonitoringManagementFulfilled,
  disableServerMonitoringManagementRejected,
  getServerMonitoringStatusRequest,
  getAllServersMonitoringStatusRequest,
  getServerMonitoringStatusFulfilled,
  getServerMonitoringStatusRejected,
} from './actions';
import endpoints, { api } from './endpoints';
import {
  CloudProviderEnum,
  FormSupportServerProps,
  ListServerFieldsDataProps,
  ModelTypeEnum,
} from './interfaces';
import {
  AttachServerRequestProps,
  DetachServerRequestProps,
  GetAllServersRequestProps,
} from './requestInterfaces';

const delay = time => new Promise(resolve => setTimeout(resolve, time));

function* newEnvironmentRequestSaga({ payload }) {
  try {
    const { data } = yield api.post({
      url: endpoints.newEnvironment(),
      data: payload,
    });

    return yield all([
      put(newEnvironmentFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t(`${data.message.code.toUpperCase()}`),
        })
      ),
      put(push(`/environments/${data.environment_uuid}/configuration`)),
    ]);
  } catch (error) {
    return yield put(unlinkInstanceRejected());
  }
}

function* toggleBlockInstancesRequestSaga({ payload }) {
  const {
    environmentUuid,
    instancesIds,
    action,
    blockDuration,
    notifyUsers,
  } = payload;

  try {
    yield api.post({
      url: endpoints.toggleBlockInstances(environmentUuid, action),
      data: {
        instances_uuids: instancesIds,
        blocked_ttl_minutes: blockDuration,
        notify_users: notifyUsers,
      },
    });

    return yield all([
      put(toggleBlockInstancesFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t(`${action.toUpperCase()}_MULTIPLE_INSTANCES_KEY`),
        })
      ),
    ]);
  } catch (error) {
    return yield put(toggleBlockInstancesRejected());
  }
}

function* terminateMultipleInstancesRequestSaga({ payload }) {
  const { id, instancesId, query } = payload;
  try {
    yield api.post({
      url: endpoints.terminateMultipleInstance(id),
      data: {
        instances_uuids: instancesId,
      },
    });
    return yield all([
      put(terminateMultipleInstancesFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('TERMINATE_MULTIPLE_INSTANCES_KEY'),
        })
      ),
      put(getAllInstancesRequest({ id, query })),
    ]);
  } catch (error) {
    return yield put(terminateMultipleInstancesRejected());
  }
}

function* publishNewImageRequestSaga({ payload }) {
  const {
    environmentUuid,
    instanceId,
    query,
    values,
    type,
    partnerUuid,
    server_type,
  } = payload;

  try {
    yield api.post({
      url: endpoints.publishNewImage(environmentUuid, instanceId),
      data: {
        ...values,
        publication_type: type,
        notification_email: values.notification_email
          .split(',')
          .filter(Boolean),
      },
    });
    return yield all([
      put(publishNewImageFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('ENVIRONMENTS_PAGE.NEW_PUBLICATION'),
        })
      ),
      put(
        partnerUuid
          ? getAllPartnerServersRequest({ id: partnerUuid, server_type, query })
          : getAllServersRequest({
              id: environmentUuid,
              type: 'preparation',
              query,
            })
      ),
    ]);
  } catch (error) {
    return yield all([
      put(publishNewImageRejected()),
      put(
        partnerUuid
          ? getAllPartnerServersRequest({ id: partnerUuid, server_type, query })
          : getAllServersRequest({
              id: environmentUuid,
              type: server_type,
              query,
            })
      ),
    ]);
  }
}

function* getEnvironmentBehaviorRequestSaga({ payload }) {
  const { environmentId } = payload;

  try {
    const { data } = yield batchRequests([
      {
        url: endpoints.getEnvironmentBehavior(environmentId, 'week'),
        method: 'GET',
      },
      {
        url: endpoints.getEnvironmentBehavior(environmentId, 'sunday'),
        method: 'GET',
      },
      {
        url: endpoints.getEnvironmentBehavior(environmentId, 'saturday'),
        method: 'GET',
      },
      {
        url: endpoints.getEnvironment(environmentId),
        method: 'GET',
      },
    ]);

    const [week, sunday, saturday, environmentDetails] = data;

    return yield put(
      getEnvironmentBehaviorFulfilled({
        environmentBehaviorWeek: week.data,
        environmentBehaviorSunday: sunday.data,
        environmentBehaviorSaturday: saturday.data,
        environmentSelected: environmentDetails.data,
      })
    );
  } catch (error) {
    return yield put(getEnvironmentBehaviorRejected());
  }
}

function* editEnvironmentBehaviorRequestSaga({ payload }) {
  const { environmentId, values } = payload;

  try {
    yield batchRequests([
      {
        url: endpoints.editEnvironmentBehavior(environmentId, 'week'),
        data: values.week,
        method: 'PATCH',
      },
      {
        url: endpoints.editEnvironmentBehavior(environmentId, 'saturday'),
        data: values.saturday,
        method: 'PATCH',
      },
      {
        url: endpoints.editEnvironmentBehavior(environmentId, 'sunday'),
        data: values.sunday,
        method: 'PATCH',
      },
      {
        url: endpoints.editEnvironmentBehaviorMode(environmentId),
        data: values.mode,
        method: 'PATCH',
      },
    ]);

    return yield all([
      put(editEnvironmentBehaviorFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('BEHAVIOR_MESSAGE_KEY'),
        })
      ),
      put(getEnvironmentBehaviorRequest({ environmentId })),
    ]);
  } catch (error) {
    return yield put(editEnvironmentBehaviorRejected());
  }
}

function* detachServerRequestSaga({ payload }) {
  const {
    environmentUuid,
    instanceId,
    query,
    type,
    partnerUuid,
  }: DetachServerRequestProps = payload;

  try {
    const { data } = yield api.delete({
      url: endpoints.detachServer(environmentUuid, instanceId),
    });

    return yield all([
      put(detachServerFulfilled(type)),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t(`${data.message.code.toUpperCase()}`),
        })
      ),
      put(
        partnerUuid
          ? getAllPartnerServersRequest({ id: partnerUuid, type, query })
          : getAllServersRequest({ id: environmentUuid, type, query })
      ),
    ]);
  } catch (error) {
    return yield put(detachServerRejected(type));
  }
}

function* getUrlsEnvironmentsDashboardRequestSaga({ payload }) {
  try {
    const { data } = yield api.get({
      url: endpoints.getHrlsEnvironmentDashboard(
        payload.id,
        payload.intervalTime
      ),
    });
    return yield all([put(getUrlsEnvironmentsDashboardFulfilled(data))]);
  } catch (error) {
    return yield put(getUrlsEnvironmentsDashboardRejected());
  }
}

function* getAlarmsInstanceRequestSaga({ payload }) {
  const { id, instanceId } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getAlarmsInstance(id, instanceId),
    });
    return yield put(getAlarmsInstanceFulfilled(data));
  } catch (error) {
    return yield put(getAlarmsInstanceRejected());
  }
}

function* getSessionsChartDashboardRequestSaga({ payload }) {
  try {
    const { data } = yield api.get({
      url: endpoints.getSessionsData(
        payload.id,
        payload.begin_time,
        payload.end_time
      ),
    });
    return yield all([put(getSessionsChartDashboardFulfilled(data))]);
  } catch (error) {
    return yield put(getSessionsChartDashboardRejected());
  }
}

function* getInstanceChartDashboardRequestSaga({ payload }) {
  try {
    const { data } = yield api.get({
      url: endpoints.getInstanceData(
        payload.id,
        payload.begin_time,
        payload.end_time
      ),
    });
    return yield all([put(getInstanceChartDashboardFulfilled(data))]);
  } catch (error) {
    return yield put(getInstanceChartDashboardRejected());
  }
}

function* getMaintenanceRequestSaga({ payload }) {
  const {
    id,
    hasBlockInstancesPermission,
    hasDisplayWarningPermission,
    hasRemoveSessionsPermission,
  } = payload;

  try {
    interface Request {
      url: string;
    }

    const requests: Request[] = [];
    const permissions: string[] = [];

    if (hasDisplayWarningPermission) {
      requests.push({
        url: endpoints.getMaintenanceDisplayWarning(id),
      });
      permissions.push('displayWarning');
    }

    if (hasBlockInstancesPermission) {
      requests.push({
        url: endpoints.getMaintenanceBlockInstances(id),
      });
      permissions.push('blockInstances');
    }

    if (hasRemoveSessionsPermission) {
      requests.push({
        url: endpoints.getMaintenanceRemoveSessions(id),
      });
      permissions.push('removeSessions');
    }

    const { data } = yield batchRequests(requests);

    const results: { [key: string]: any } = {};
    permissions.forEach((permission, index) => {
      results[permission] = data[index];
    });

    const displayWarning = results.displayWarning || null;
    const blockInstances = results.blockInstances || null;
    const removeSessions = results.removeSessions || null;

    interface MaintenanceKeys {
      environmentMaintenanceDisplayWarning?: MaintenanceDisplay;
      environmentMaintenanceBlockInstances?: BlockInstancesFormDisplay;
      environmentMaintenanceRemoveSessions?: RemoveSessionsFormDisplay;
    }

    const keys: MaintenanceKeys = {};

    if (hasBlockInstancesPermission) {
      keys.environmentMaintenanceBlockInstances = blockInstances.data;
    }
    if (hasDisplayWarningPermission) {
      keys.environmentMaintenanceDisplayWarning = displayWarning.data;
    }
    if (hasRemoveSessionsPermission) {
      keys.environmentMaintenanceRemoveSessions = removeSessions.data;
    }

    return yield put(getMaintenanceFulfilled(keys));
  } catch (error) {
    return yield put(getMaintenanceRejected());
  }
}

function* unlinkInstanceRequestSaga({ payload }) {
  try {
    const { data } = yield api.post({
      url: endpoints.unlinkInstance(payload.id, payload.uuidInstance),
    });
    return yield all([
      put(unlinkInstanceFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t(`${data.message.code.toUpperCase()}`),
        })
      ),
      put(push('/environments')),
    ]);
  } catch (error) {
    return yield put(unlinkInstanceRejected());
  }
}

function* editSecurityRequestSaga({ payload }) {
  const {
    securityValues,
    zeroTrustValues,
    deviceValidationValues,
    id,
  } = payload;

  try {
    const { data } = yield batchRequests([
      {
        url: endpoints.editSecurity(id),
        method: 'PUT',
        data: securityValues,
      },
      {
        url: endpoints.editEnvironment(id),
        method: 'PATCH',
        data: { zero_trust: zeroTrustValues },
      },
      {
        url: endpoints.editEnvironment(id),
        method: 'PATCH',
        data: { device_validation_settings: deviceValidationValues },
      },
    ]);

    if (!isRequestOK(data[1]?.status)) {
      let errorMessage = 'UNEXPECTED_ERROR';

      if (
        data[1]?.data?.errors?.zero_trust[0] ===
        'Zero Trust cannot be enabled unless partner uses the new login frontend'
      ) {
        errorMessage = 'ENVIRONMENTS_PAGE.ZERO_TRUST_NEW_FRONTEND_KEY';
      } else if (
        data[1]?.data?.errors?.zero_trust[0] ===
        'Invalid address or network in allow_list'
      ) {
        errorMessage = 'ENVIRONMENTS_PAGE.INVALID_IP_KEY';
      } else if (
        data[1]?.data?.errors?.default_zone[0].includes(
          "Invalid 'default_zone' value for provider"
        )
      ) {
        errorMessage = 'ENVIRONMENTS_PAGE.INVALID_DEFAULT_ZONE';
      }
      return yield all([
        put(editSecurityRejected()),
        put(messagesRequest({ message: i18n.t(errorMessage), type: 'error' })),
      ]);
    }
    return yield all([
      put(editSecurityFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('ENVIRONMENTS_PAGE.SECURITY_DEFAULTS_SUCCESS_KEY'),
        })
      ),
      put(getEnvironmentRequest({ id, skipProvider: true })),
      put(getSecurityStateRequest(id)),
    ]);
  } catch (error) {
    return yield put(editSecurityRejected());
  }
}

function* duplicateModelRequestSaga({ payload }) {
  const { id, modelUuid, values, query } = payload;
  try {
    yield api.post({
      url: endpoints.duplicateModel(id, modelUuid),
      data: values,
    });
    return yield all([
      put(duplicateModelFulfilled()),
      put(getAllModelsRequest({ id, query })),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('ENVIRONMENTS_PAGE.MODEL_SUCCESSFULLY_DUPLICATE_KEY'),
        })
      ),
    ]);
  } catch (error) {
    return yield put(duplicateModelRejected());
  }
}

function* registerNewInstanceRequestSaga({ payload }) {
  try {
    yield api.post({
      url: endpoints.registerNewInstance(payload.environmentUuid),
      data: payload.values,
    });
    return yield all([
      put(registerNewInstanceFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: 'Nova instância registrada com sucesso!',
        })
      ),
    ]);
  } catch (error) {
    return yield put(registerNewInstanceRejected());
  }
}

function* getAllSessionsInInstanceRequestSaga({ payload }) {
  try {
    const { data } = yield api.get({
      url: endpoints.getSessionsInInstance(
        payload?.environmentId,
        payload?.instanceId,
        payload?.query
      ),
    });

    return yield put(getAllSessionsInInstanceFulfilled(data));
  } catch (error) {
    return yield put(getAllSessionsInInstanceRejected());
  }
}

function* getInstanceObservabilityRequestSaga({ payload }) {
  try {
    const { data } = yield api.get({
      url: endpoints.getInstanceObservability(payload?.instanceUuid),
    });

    return yield put(getInstanceObservabilityFulfilled(data));
  } catch (error) {
    return yield put(getInstanceObservabilityRejected());
  }
}

function* terminateInstanceRequestSaga({ payload }) {
  try {
    yield api.post({
      url: endpoints.terminateInstance(payload.id, payload.instanceUuid),
    });
    return yield all([
      put(terminateInstanceFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: 'Instância terminada com sucesso!',
        })
      ),
    ]);
  } catch (error) {
    return yield put(terminateInstanceRejected());
  }
}

function* removeEnvironmentRequestsSaga({ payload }) {
  const { environmentUuid, query, partner_uuid, company_uuid } = payload;

  try {
    yield api.delete({
      url: endpoints.removeEnvironment(environmentUuid),
    });

    return yield all([
      put(removeEnvironmentFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('ENVIRONMENTS_SUCCESS_KEY'),
        })
      ),
      put(getAllEnvironmentsRequest({ query, partner_uuid, company_uuid })),
    ]);
  } catch (error) {
    return yield put(removeEnvironmentRejected());
  }
}

function* rebootInstanceRequestSaga({ payload }) {
  const { environmentId, instanceId } = payload;

  try {
    const { data } = yield api.post({
      url: endpoints.rebootInstance(environmentId, instanceId),
    });

    return yield all([
      put(rebootInstanceFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t(`${data.message.code.toUpperCase()}`),
        })
      ),
    ]);
  } catch (error) {
    return yield put(rebootInstanceRejected());
  }
}

function* removeInstanceRequestSaga({ payload }) {
  try {
    yield api.post({
      url: endpoints.removeInstance(payload.id),
      data: {
        instances_ids: payload.checks,
      },
    });
    return yield all([
      put(removeInstanceFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: 'Instância removida com sucesso!',
        })
      ),
      put(push('/environments')),
    ]);
  } catch (error) {
    return yield put(removeInstanceRejected());
  }
}

function* editMaintenanceEnvironmentsRequestSaga({ payload }) {
  const {
    id,
    displayValues,
    blockInstancesValues,
    changedItems,
    hasBlockInstancesPermission,
    hasDisplayWarningPermission,
    hasRemoveSessionsPermission,
    removeSessionsValues,
  } = payload;

  const batchObject: BatchRequest[] = [];

  if (changedItems.includes('display')) {
    batchObject.push({
      url: endpoints.editMaintenanceDisplayWarning(id),
      method: 'PUT',
      data: displayValues,
    });
  }
  if (changedItems.includes('blockInstances')) {
    batchObject.push({
      url: endpoints.editMaintenanceBlockInstances(id),
      method: 'PUT',
      data: blockInstancesValues,
    });
  }
  if (changedItems.includes('removeSessions')) {
    batchObject.push({
      url: endpoints.editMaintenanceRemoveSessions(id),
      method: 'PUT',
      data: removeSessionsValues,
    });
  }

  try {
    yield batchRequests(batchObject);

    return yield all([
      put(editMaintenanceEnvironmentsFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('CHANGES_SAVED'),
        })
      ),
      put(getEnvironmentRequest({ id, skipProvider: true })),
      put(
        getMaintenanceRequest({
          id,
          hasBlockInstancesPermission,
          hasDisplayWarningPermission,
          hasRemoveSessionsPermission,
        })
      ),
    ]);
  } catch (error) {
    return yield put(editMaintenanceEnvironmentsRejected());
  }
}

function* activateInstanceRequestSaga({ payload }) {
  const { id, instanceValue, query, providerType } = payload;
  try {
    const { data } = yield api.post({
      url: endpoints.activateInstance(id),
      data: {
        quantity: instanceValue,
      },
    });

    yield put(
      messagesRequest({
        type: 'success',
        message: i18n.t(`${data.message.code.toUpperCase()}`),
      })
    );

    yield put(getEnvironmentRequest({ id, skipProvider: true }));

    if (providerType === 'oci') {
      yield call(delay, 60000);
    } else {
      yield call(delay, 10000);
    }
    return yield all([
      put(activateInstanceFulfilled()),
      put(getAllInstancesRequest({ id, query })),
    ]);
  } catch (error) {
    return yield put(activateInstanceRejected());
  }
}

function* removeSessionsInstanceRequestSaga({ payload }) {
  const { values, getSessions } = payload;

  try {
    yield api.post({
      url: endpoints.removeSessionsInstance(),
      data: values,
    });

    return yield all([
      put(removeSessionsInstanceFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('REMOVE_SESSION_SUCCESS_KEY'),
        })
      ),
      put(modalClose()),
      getSessions && put(getSessions()),
    ]);
  } catch (error) {
    return yield put(removeSessionsInstanceRejected());
  }
}

function* getAllEnvironmentsRequestSaga({ payload }) {
  try {
    const { data } = yield api.get({
      url: endpoints.getAllEnvironments(payload),
    });

    return yield put(getAllEnvironmentsFulfilled(data));
  } catch (error) {
    return yield put(getAllEnvironmentsRejected());
  }
}

function* getAllEnvironmentsOperatorRequestSaga({ payload }) {
  try {
    const { data } = yield api.get({
      url: endpoints.getAllEnvironmentsOperator(payload),
    });

    return yield put(getAllEnvironmentsOperatorFulfilled(data));
  } catch (error) {
    return yield put(getAllEnvironmentsOperatorRejected());
  }
}

function* getEnvironmentRequestSaga({ payload }) {
  const { id, skipProvider } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getEnvironment(id || payload),
    });

    if (!skipProvider) {
      yield all([
        put(
          getProviderResourcesRequest({
            environment: data,
          })
        ),
      ]);
    }

    return yield all([
      put(getEnvironmentFulfilled(data)),
      put(
        selectCompany({
          id: data.company.uuid,
          name: data.company.display_name,
          shortName: data.company.display_name,
        })
      ),
      put(
        selectPartner({
          id: data.partner.uuid,
          name: data.partner.name,
          shortName: data.partner.name,
        })
      ),
    ]);
  } catch (error) {
    return yield put(getEnvironmentRejected());
  }
}

function* getSecurityStateSaga({ payload }) {
  try {
    const { data } = yield api.get({
      url: endpoints.getSecurity(payload),
    });

    return yield put(getSecurityStateFulfilled(data));
  } catch (error) {
    return yield put(getSecurityStateRejected());
  }
}

function* getAllInstancesRequestSaga({ payload }) {
  try {
    const { data } = yield api.get({
      url: endpoints.getScaleInstances(payload.id, payload.query),
    });
    return yield put(getAllInstancesFulfilled(data));
  } catch (error) {
    return yield put(getAllInstancesRejected());
  }
}

function* getPreparationServerRequestSaga({ payload }) {
  const {
    id,
    query,
    force_refresh = false,
  }: GetAllServersRequestProps = payload;

  try {
    const { data }: AxiosResponse<ListServerFieldsDataProps> = yield api.get({
      url: endpoints.getAllServers(id, force_refresh, query, 'preparation'),
    });

    const preparationServer = data?.results[0];

    return yield put(getPreparationServerFulfilled(preparationServer));
  } catch (error) {
    return yield put(getPreparationServerRejected());
  }
}

function* getSupportServersRequestSaga({
  payload,
}: {
  payload: GetAllServersRequestProps;
}) {
  const { id, query, force_refresh = false } = payload;

  try {
    const { data }: AxiosResponse<ListServerFieldsDataProps> = yield api.get({
      url: endpoints.getAllServers(id, force_refresh, query, 'support'),
    });

    const serversToFetchMonitoringStatus = data.results.filter(
      server => server.monitoring_management_enabled
    );

    yield put(getSupportServerFulfilled(data));

    if (serversToFetchMonitoringStatus.length > 0) {
      if (!force_refresh) {
        yield delay(5000);
      }

      yield put(
        getAllServersMonitoringStatusRequest({
          environment_uuid: id,
          servers: serversToFetchMonitoringStatus,
        })
      );
    }

    return true;
  } catch (error) {
    yield put(getSupportServerRejected());
    return false;
  }
}

function* getAllServersRequestSaga({ payload }) {
  const {
    id,
    query,
    force_refresh = false,
    type,
  }: GetAllServersRequestProps = payload;

  if (type === 'preparation') {
    return yield put(getPreparationServerRequest(payload));
  }
  if (type === 'support') {
    return yield put(getSupportServerRequest(payload));
  }

  try {
    const { data } = yield api.get({
      url: endpoints.getAllServers(id, force_refresh, query, type),
    });

    if (!type) {
      return yield put(getAllServersFulfilled(data));
    }

    return put(getAllServersFulfilled(data));
  } catch (error) {
    return yield put(getAllServersRejected());
  }
}

function* getZonesRequestSaga({ payload }) {
  const { environment } = payload;

  try {
    const {
      data: { results },
    } = yield api.get({
      url: endpoints.providerResources(environment?.environment_uuid).zones,
    });
    return yield put(getZonesFulFilled(results));
  } catch {
    return yield put(getZonesRejected());
  }
}

function* getAllModelsRequestSaga({ payload }) {
  const { id, query } = payload;

  try {
    const { data } = yield api.get({
      url: endpoints.getAllModels(
        id,
        query || { offset: 0, limit: 25, search: '' }
      ),
    });

    return yield all([
      put(getAllModelsFulfilled(data)),
      put(getZonesRequest({ environment: { environment_uuid: id } })),
    ]);
  } catch (error) {
    return yield put(getAllModelsRejected());
  }
}

function* getModelRequestSaga({ payload }) {
  try {
    const { data } = yield api.get({ url: payload });

    return yield put(getModelFulfilled(data));
  } catch (error) {
    return yield put(getModelRejected());
  }
}

function* registerModelRequestSaga({ payload }) {
  const { id, values, pathUrl } = payload;

  try {
    yield api.post({
      url: endpoints.registerModel(id, pathUrl),
      data: values,
    });

    return yield all([
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('MODEL_SUCCESSFULLY_REGISTERED_KEY'),
        })
      ),
      put(registerModelFulfilled()),
      put(getAllModelsRequest({ id })),
      put(modalClose()),
    ]);
  } catch (error) {
    return yield put(registerModelRejected());
  }
}

function* editModelRequestSaga({ payload }) {
  const { id, values, pathUrl } = payload;

  try {
    yield api.put({
      url: endpoints.editModel(id, `${pathUrl + values.model_uuid}/`),
      data: values,
    });

    return yield all([
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('MODEL_SUCCESSFULLY_EDITED_KEY'),
        })
      ),
      put(editModelFulfilled()),
      put(getAllModelsRequest({ id })),
      put(modalClose()),
    ]);
  } catch (error) {
    const errorMessageKey = getEditModelErrorMessageKey(error);

    if (errorMessageKey) {
      return yield all([
        put(editModelRejected()),
        put(
          messagesRequest({
            type: 'error',
            message: i18n.t(errorMessageKey),
          })
        ),
      ]);
    }

    return yield put(editModelRejected());
  }
}

function* editEnvironmentsRequestSaga({ payload }) {
  const { id, values, shouldGetEnvironmentOnSuccess = true } = payload;

  const payloadKeysToRemove = [
    'maintenance',
    'zero_trust',
    'metrics',
    'easysky_project_id',
    'behavior',
    'advanced_properties',
    'company_uuid',
    'partner_uuid',
  ];

  const updatedValues = removePayloadKeys(values, payloadKeysToRemove);

  try {
    yield api.patch({
      url: endpoints.editEnvironment(id),
      data: updatedValues,
    });

    return yield all([
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('ENVIRONMENT_SUCCESSFULLY_EDITED_KEY'),
        })
      ),
      put(editEnvironmentsFulfilled()),
      shouldGetEnvironmentOnSuccess &&
        put(getEnvironmentRequest({ id, skipProvider: true })),
    ]);
  } catch (error) {
    return yield put(editEnvironmentsRejected());
  }
}

function* removeModelRequestSaga({ payload }) {
  const { id, query, url } = payload;

  try {
    yield api.delete({ url });

    return yield all([
      put(removeModelFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('MODEL_SUCCESSFULLY_REMOVED_KEY'),
        })
      ),
      put(getAllModelsRequest({ id, query })),
    ]);
  } catch (error) {
    return yield put(removeModelRejected());
  }
}

function* removeMultipleModelsRequestSaga({ payload }) {
  const { id, query, modelsIds } = payload;

  try {
    yield api.post({
      url: endpoints.removeMultipleModels(id),
      data: {
        models_uuids: modelsIds,
      },
    });
    return yield all([
      put(removeMultipleModelsFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('SUCCESS_REMOVE_MULTIPLE_MODELS_KEY'),
        })
      ),
      put(getAllModelsRequest({ id, query })),
    ]);
  } catch (error) {
    return yield put(removeMultipleModelsRejected());
  }
}

function* getAllImagesLogsRequestSaga({ payload }) {
  const { id, instanceId, query } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getAllLogsImageEnvironments(id, instanceId, query),
    });
    return yield all([put(getAllImagesLogsFulfilled(data))]);
  } catch (error) {
    return yield put(getAllImagesLogsRejected());
  }
}

function* getBootVolumesRequestSaga({ payload }) {
  const { environment } = payload;

  try {
    const {
      data: { results },
    } = yield api.get({
      url: endpoints.providerResources(environment?.environment_uuid)
        .bootVolume,
    });
    return yield put(getBootVolumesFulFilled(results));
  } catch {
    return yield put(getBootVolumesRejected());
  }
}

function* getBootVolumeBackupsRequestSaga({ payload }) {
  const { environment } = payload;

  try {
    const {
      data: { results },
    } = yield api.get({
      url: endpoints.providerResources(environment?.environment_uuid)
        .bootVolumeBackup,
    });
    return yield put(getBootVolumeBackupsFulFilled(results));
  } catch {
    return yield put(getBootVolumeBackupsRejected());
  }
}

function* getSecurityGroupsRequestSaga({ payload }) {
  const { environment } = payload;

  try {
    const {
      data: { results },
    } = yield api.get({
      url: endpoints.providerResources(environment?.environment_uuid)
        .securityGroups,
    });
    return yield put(getSecurityGroupsFulFilled(results));
  } catch {
    return yield put(getSecurityGroupsRejected());
  }
}

function* getSubnetsRequestSaga({ payload }) {
  const { environment } = payload;

  try {
    const {
      data: { results },
    } = yield api.get({
      url: endpoints.providerResources(environment?.environment_uuid).subnets,
    });
    return yield put(getSubnetsFulFilled(results));
  } catch {
    return yield put(getSubnetsRejected());
  }
}

function* getKeyPairsRequestSaga({ payload }) {
  const { environment } = payload;

  try {
    const {
      data: { results },
    } = yield api.get({
      url: endpoints.providerResources(environment?.environment_uuid).keypairs,
    });
    return yield put(getKeyPairsFulFilled(results));
  } catch {
    return yield put(getKeyPairsRejected());
  }
}

function* getImagesRequestSaga({ payload }) {
  const { environment } = payload;

  try {
    const {
      data: { results },
    } = yield api.get({
      url: endpoints.providerResources(environment?.environment_uuid).images,
    });
    return yield put(getImagesFulFilled(results));
  } catch {
    return yield put(getImagesRejected());
  }
}

function* getListProviderResourcesRequestSaga() {
  try {
    const { data } = yield api.get({
      url: endpoints.providerResources().listProvidersResources,
    });
    return yield put(getListProviderResourcesFulFilled(data));
  } catch {
    return yield put(getListProviderResourcesRejected());
  }
}

function* getFlavorsRequestSaga({ payload }) {
  const { environment, modelType, customId } = payload;
  let flavorsEndpoint = 'amiFlavors';

  try {
    if (modelType === ModelTypeEnum.bootVolume) {
      flavorsEndpoint = 'bootVolumeFlavors';
    } else if (modelType === ModelTypeEnum.customImage) {
      flavorsEndpoint = 'customImageFlavors';
    } else if (modelType === ModelTypeEnum.bootVolumeBackup) {
      flavorsEndpoint = 'bootVolumeBackupFlavors';
    }

    const {
      data: { results },
    } = yield api.get({
      url: endpoints.providerResources(environment?.environment_uuid, customId)[
        flavorsEndpoint
      ],
    });
    return yield put(getFlavorsFulFilled(results));
  } catch {
    return yield put(getFlavorsRejected());
  }
}

function* getAwsResourcesRequestSaga({ payload }) {
  const { environment, reloadEnvProviderResources } = payload;

  try {
    if (reloadEnvProviderResources) {
      return yield all([
        put(getZonesRequest({ environment })),
        put(getSecurityGroupsRequest({ environment })),
        put(getKeyPairsRequest({ environment })),
        put(getImagesRequest({ environment })),
        put(getFlavorsRequest({ environment })),
        put(
          getProviderResourcesFulfilled({
            environment_uuid: environment?.environment_uuid,
          })
        ),
      ]);
    }
    return yield all([
      put(getZonesRequest({ environment })),
      put(getListProviderResourcesRequest()),
      put(getProviderResourcesFulfilled()),
      put(getImagesRequest({ environment })),
    ]);
  } catch {
    return yield put(getProviderResourcesRejected());
  }
}

function* getOciResourcesRequestSaga({ payload }) {
  const {
    environment,
    modelType,
    customId,
    reloadEnvProviderResources,
  } = payload;

  const getRequestByModelType = {
    [ModelTypeEnum.customImage]: getImagesRequest({ environment }),
    [ModelTypeEnum.bootVolume]: getBootVolumesRequest({ environment }),
    [ModelTypeEnum.bootVolumeBackup]: getBootVolumeBackupsRequest({
      environment,
    }),
  };
  try {
    if (reloadEnvProviderResources) {
      yield all([
        put(getSecurityGroupsRequest({ environment })),
        put(getSubnetsRequest({ environment })),
        put(
          getProviderResourcesFulfilled({
            environment_uuid: environment?.environment_uuid,
          })
        ),
      ]);
    }

    if (customId) {
      return yield put(getFlavorsRequest({ environment, modelType, customId }));
    }

    if (modelType) {
      return yield put(getRequestByModelType[modelType]);
    }

    return yield all([
      put(getZonesRequest({ environment })),
      put(getListProviderResourcesRequest()),
      put(getProviderResourcesFulfilled()),
    ]);
  } catch {
    return yield put(getProviderResourcesRejected());
  }
}

function* getProviderResourcesRequestSaga({ payload }) {
  const { environment } = payload;

  try {
    if (environment?.provider?.type === CloudProviderEnum.AWS) {
      return yield put(getAwsResourcesRequest(payload));
    }
    if (environment?.provider?.type === CloudProviderEnum.OCI) {
      return yield put(getOciResourcesRequest(payload));
    }
    return yield all([
      put(getListProviderResourcesRequest()),
      put(getProviderResourcesFulfilled()),
    ]);
  } catch {
    return yield put(getProviderResourcesRejected());
  }
}

function* attachServerRequestSaga({ payload }) {
  const {
    environmentUuid,
    values,
    type,
    query,
  }: AttachServerRequestProps = payload;

  const isApplication =
    (values as FormSupportServerProps).include_instance_as_application_server ||
    false;

  try {
    const { data } = yield api.post({
      url: endpoints.attachServer(environmentUuid),
      data: { ...values, server_type: type },
    });
    return yield all([
      put(attachServerFulfilled(type)),
      put(
        messagesRequest({
          type: 'success',
          message: isApplication
            ? i18n.t('TURNED_SERVER_MSG_KEY')
            : i18n.t(`${data.message.code.toUpperCase()}`),
        })
      ),
      put(getAllServersRequest({ id: environmentUuid, type, query })),
    ]);
  } catch (error) {
    return yield put(attachServerRejected(type));
  }
}

function* startServerRequestSaga({ payload }) {
  const { id, environmentUuid, query, partnerUuid, server_type } = payload;

  try {
    const { data } = yield api.post({
      url: endpoints.startServer(environmentUuid, id),
    });

    return yield all([
      put(startServerFulfilled(server_type)),
      put(modalClose()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t(`${data.message.code.toUpperCase()}`),
        })
      ),
      put(
        partnerUuid
          ? getAllPartnerServersRequest({ id: partnerUuid, server_type, query })
          : getAllServersRequest({
              id: environmentUuid,
              type: server_type,
              query,
            })
      ),
    ]);
  } catch (error) {
    return yield all([
      put(startServerRejected(server_type)),
      put(
        partnerUuid
          ? getAllPartnerServersRequest({ id: partnerUuid, server_type, query })
          : getAllServersRequest({
              id: environmentUuid,
              type: server_type,
              query,
            })
      ),
    ]);
  }
}

function* stopServerRequestSaga({ payload }) {
  const { id, environmentUuid, query, partnerUuid, server_type } = payload;

  try {
    const { data } = yield api.post({
      url: endpoints.stopServer(environmentUuid, id),
    });

    return yield all([
      put(stopServerFulfilled(server_type)),
      put(modalClose()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t(`${data.message.code.toUpperCase()}`),
        })
      ),
      put(
        partnerUuid
          ? getAllPartnerServersRequest({ id: partnerUuid, server_type, query })
          : getAllServersRequest({
              id: environmentUuid,
              type: server_type,
              query,
            })
      ),
    ]);
  } catch (error) {
    return yield all([
      put(stopServerRejected(server_type)),
      put(
        partnerUuid
          ? getAllPartnerServersRequest({ id: partnerUuid, server_type, query })
          : getAllServersRequest({
              id: environmentUuid,
              type: server_type,
              query,
            })
      ),
    ]);
  }
}

function* restartServerRequestSaga({ payload }) {
  const { id, environmentUuid, query } = payload;

  try {
    const { data } = yield api.post({
      url: endpoints.restartServer(environmentUuid, id),
    });

    return yield all([
      put(restartServerFulfilled()),
      put(modalClose()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t(`${data.message.code.toUpperCase()}`),
        })
      ),
      put(
        getAllServersRequest({ id: environmentUuid, type: 'support', query })
      ),
    ]);
  } catch (error) {
    return yield all([
      put(restartServerRejected()),
      put(
        getAllServersRequest({ id: environmentUuid, type: 'support', query })
      ),
    ]);
  }
}

function* toggleBlockMultipleInstancesRequestSaga({ payload }) {
  const { id, checks, query, blockDuration, notifyUsers } = payload;

  try {
    yield api.post({
      url: endpoints.toggleBlockUnblockMultipleInstances(id),
      data: {
        instances_uuids: checks,
        blocked_ttl_minutes: blockDuration,
        notify_users: notifyUsers,
      },
    });
    return yield all([
      put(toggleBlockMultipleInstancesFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('TOGGLE_BLOCK_UNBLOCK_INSTANCE_SUCCESS_KEY'),
        })
      ),
      put(getAllInstancesRequest({ id, query })),
    ]);
  } catch (error) {
    return yield put(toggleBlockMultipleInstancesRejected());
  }
}

function* stopTimeRequestSaga({ payload }) {
  const {
    serverId,
    environmentUuid,
    values,
    query,
    partnerUuid,
    server_type,
  } = payload;
  try {
    const { data } = yield api.post({
      url: endpoints.stopTime(environmentUuid, serverId),
      data: values,
    });
    return yield all([
      put(stopTimeFulfilled(data)),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t(`${data.message.code.toUpperCase()}`),
        })
      ),
      put(
        partnerUuid
          ? getAllPartnerServersRequest({ id: partnerUuid, server_type, query })
          : getPreparationServerRequest({ id: environmentUuid })
      ),
    ]);
  } catch (error) {
    return yield put(stopTimeRejected());
  }
}

function* connectAsRequestSaga({ payload }) {
  const { environmentUuid, instanceId, values } = payload;

  try {
    const { data } = yield api.post({
      url: endpoints.connectAs(environmentUuid, instanceId),
      data: values,
    });

    window.open(data.url, '_blank');

    return yield put(connectAsFulfilled());
  } catch (error) {
    return yield put(connectAsRejected());
  } finally {
    yield put(modalClose());
  }
}

function* getDashboardSessionsGraphRequestSaga({ payload }) {
  const { id, query } = payload;

  try {
    const { data } = yield api.get({
      url: endpoints.getDashboardSessionsGraph(id, query),
    });

    return yield put(getDashboardSessionsGraphFulfilled(data));
  } catch (error) {
    return yield put(getDashboardSessionsGraphRejected());
  }
}

function* getDashboardEnvironmentCostGraphRequestSaga({ payload }) {
  const { id, query } = payload;

  try {
    const { data } = yield api.get({
      url: endpoints.getDashboardCostGraph(id, query),
    });

    return yield put(getDashboardEnvironmentCostGraphFulfilled(data));
  } catch (error) {
    return yield put(getDashboardEnvironmentCostGraphRejected());
  }
}

function* getFlavorsCostRequestSaga({ payload }) {
  const { id, query } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getEnvironmentFlavorsCost(id, query),
    });
    return yield put(getFlavorsCostFulfilled(data));
  } catch (error) {
    return yield put(getFlavorsCostRejected());
  }
}

function* getAllApplicationsAutoskyRequestSaga({ payload }) {
  const { id, query } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getAllApplicationsAutosky(id, query),
    });

    return yield put(getAllApplicationsAutoskyFulfilled(data));
  } catch (error) {
    return yield put(getAllApplicationsAutoskyRejected());
  }
}

function* getAllApplicationsPlatformRequestSaga({ payload }) {
  const { id, query } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getAllApplicationsPlatform(id, query),
    });

    return yield put(getAllApplicationsPlatformFulfilled(data));
  } catch (error) {
    return yield put(getAllApplicationsPlatformRejected());
  }
}
function* getClientsApplicationsAutoskyRequestSaga({ payload }) {
  const { id, query, name, state } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getClientsApplicationsAutosky(id, query, name, state),
    });

    return yield put(getClientsApplicationsAutoskyFulfilled(data));
  } catch (error) {
    return yield put(getClientsApplicationsAutoskyRejected());
  }
}

function* getClientsApplicationsPlatformRequestSaga({ payload }) {
  const { id, query, code, state } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getClientsApplicationsPlatform(id, query, code, state),
    });

    return yield put(getClientsApplicationsPlatformFulfilled(data));
  } catch (error) {
    return yield put(getClientsApplicationsPlatformRejected());
  }
}

function* renameClientsApplicationsAutoskyRequestSaga({ payload }) {
  const { id, name, newName, query } = payload;
  try {
    const { data } = yield api.patch({
      url: endpoints.renameClientsApplicationsAutosky(id),
      data: { old_name: name, new_name: newName },
    });

    return yield all([
      put(renameClientsApplicationsAutoskyFulfilled(data)),
      put(getAllApplicationsAutoskyRequest({ id, query })),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('RENAME_APP_SUCCESSFULLY_KEY'),
        })
      ),
    ]);
  } catch (error) {
    return yield put(renameClientsApplicationsAutoskyRejected());
  }
}

function* removeClientsApplicationsAutoskyRequestSaga({ payload }) {
  const { id, name, query } = payload;
  try {
    const { data } = yield api.post({
      url: endpoints.removeClientsApplicationsAutosky(id),
      data: { name },
    });

    return yield all([
      put(removeClientsApplicationsAutoskyFulfilled(data)),
      put(getAllApplicationsAutoskyRequest({ id, query })),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('REMOVE_APP_SUCCESSFULLY_KEY'),
        })
      ),
    ]);
  } catch (error) {
    return yield put(removeClientsApplicationsAutoskyRejected());
  }
}

function* changeStateClientsApplicationsAutoskyRequestSaga({ payload }) {
  const { id, name, query, state, app_uuids } = payload;
  try {
    const { data } = yield api.patch({
      url: endpoints.changeStateClientsApplicationsAutosky(id),
      data: { name, state, app_uuids },
    });

    return yield all([
      put(changeStateClientsApplicationsAutoskyFulfilled(data)),
      put(getAllApplicationsAutoskyRequest({ id, query })),
      put(
        messagesRequest({
          type: 'success',
          message:
            state === 'active'
              ? i18n.t('ACTIVATED_SUCCESSFULLY_KEY')
              : i18n.t('INACTIVATED_SUCCESSFULLY_KEY'),
        })
      ),
    ]);
  } catch (error) {
    return yield put(changeStateClientsApplicationsAutoskyRejected());
  }
}

function* includeClientsApplicationsAutoskyRequestSaga({ payload }) {
  const { id, name, query, state, cli_uuids } = payload;
  try {
    const { data } = yield api.post({
      url: endpoints.includeClientsApplicationsAutosky(id),
      data: { name, state, cli_uuids },
    });

    return yield all([
      put(includeClientsApplicationsAutoskyFulfilled(data)),
      put(getAllApplicationsAutoskyRequest({ id, query })),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('INCLUDE_SUCCESSFULLY_KEY'),
        })
      ),
    ]);
  } catch (error) {
    return yield put(includeClientsApplicationsAutoskyRejected());
  }
}

function* getClientsToIncludeApplicationsAutoskyRequestSaga({ payload }) {
  const { id, query, name } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getClientsToIncludeApplicationsAutosky(id, query, name),
    });

    return yield put(getClientsToIncludeApplicationsAutoskyFulfilled(data));
  } catch (error) {
    return yield put(getClientsToIncludeApplicationsAutoskyRejected());
  }
}

function* migrateEnvironmentRequestSaga({ payload }) {
  const {
    environmentUuid,
    partnerUuid,
    reason,
    companyUuidToRedirect,
    companyNameToRedirect,
    partnerNameToRedirect,
    code,
  } = payload;

  try {
    const data = {
      partner_uuid_to_migrate: partnerUuid,
      migrate_reason: reason,
      ...(code && { restricted_action_code: code }),
    };

    yield api.post({
      url: endpoints.migrateEnvironment(environmentUuid),
      data,
    });

    yield put(migrateEnvironmentFulfilled());

    if (code) {
      yield all([
        put(
          selectCompany({
            id: companyUuidToRedirect,
            name: companyNameToRedirect,
            shortName: companyNameToRedirect,
          })
        ),
        put(
          selectPartner({
            name: partnerNameToRedirect,
            shortName: partnerNameToRedirect,
            id: partnerUuid,
          })
        ),
        put(push(`/environments/${environmentUuid}/instances`)),
        put(modalClose()),
        put(
          messagesRequest({
            type: 'success',
            message: i18n.t('ENVIRONMENT_SUCCESSFULLY_MIGRATED_KEY'),
          })
        ),
      ]);
    }
  } catch (responseWithError) {
    const response = responseWithError && (responseWithError as any).response;

    yield all([
      put(setMigrateErrors(response?.data?.invalid_settings || [])),
      put(modalClose()),
      put(migrateEnvironmentRejected()),
    ]);
  }
}

function* getEnvironmentPerformanceCPURequestSaga({ payload }) {
  const { id, query } = payload;

  try {
    const { data } = yield api.get({
      url: endpoints.getEnvironmentPerformanceCPU(id, query),
    });

    return yield put(getEnvironmentPerformanceCPUFulfilled(data));
  } catch (error) {
    return yield put(getEnvironmentPerformanceCPURejected());
  }
}

function* getEnvironmentPerformanceMemoryRequestSaga({ payload }) {
  const { id, query } = payload;

  try {
    const { data } = yield api.get({
      url: endpoints.getEnvironmentPerformanceMemory(id, query),
    });

    return yield put(getEnvironmentPerformanceMemoryFulfilled(data));
  } catch (error) {
    return yield put(getEnvironmentPerformanceMemoryRejected());
  }
}

function* getEnvironmentPerformanceOperationalTimeRequestSaga({ payload }) {
  const { id, query } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getEnvironmentPerformanceOperationalTime(id, query),
    });

    return yield put(getEnvironmentPerformanceOperationalTimeFulfilled(data));
  } catch (error) {
    return yield put(getEnvironmentPerformanceOperationalTimeRejected());
  }
}

function* getEnvironmentMonitoringRequestSaga({ payload }) {
  try {
    const { data } = yield api.get({
      url: endpoints.getEnvironmentMonitoring(payload.id),
    });
    return yield put(getEnvironmentMonitoringFulfilled(data));
  } catch (error) {
    return yield put(getEnvironmentMonitoringRejected());
  }
}

function* editEnvironmentMonitoringRequestSaga({ payload }) {
  const { id, values } = payload;
  const emailsList: string[] = values?.monitoring_alerts_emails
    .split(',')
    .filter(Boolean);
  try {
    yield api.patch({
      url: endpoints.editEnvironmentMonitoring(id),
      data: { ...values, monitoring_alerts_emails: emailsList },
    });
    return yield all([
      put(editEnvironmentMonitoringFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('MONITORING_PAGE.MONITORING_SUCCESSFULLY_SET_KEY'),
        })
      ),
      put(getEnvironmentMonitoringRequest({ id })),
    ]);
  } catch (error) {
    return yield put(editEnvironmentMonitoringRejected());
  }
}

function* getMonitoringHistoryRequestSaga({ payload }) {
  const { id, query, start_date, end_date } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getMonitoringHistory(id, query, start_date, end_date),
    });
    return yield put(getMonitoringHistoryFulfilled(data));
  } catch (error) {
    return yield put(getMonitoringHistoryRejected());
  }
}

function* getPublicationScheduleRequestSaga({ payload }) {
  const { id, query } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getPublicationSchedule(id, query),
    });

    return yield put(getPublicationScheduleFulfilled(data));
  } catch (error) {
    return yield put(getPublicationScheduleRejected());
  }
}

function* setPublicationScheduleRequestSaga({ payload }) {
  const { id, query, values } = payload;
  const emailsList: string[] = values?.notification_emails
    .split(',')
    .filter(Boolean);

  const replaceInstancesIn = values?.replace_instances || {};
  const replaceInstances = { ...replaceInstancesIn };

  if (!replaceInstances.notify_users) {
    delete replaceInstances.instance_block_user_message;
  }

  const allowBlockedTtlAndNotifyUsers =
    replaceInstances.block_instances === true;

  if (!allowBlockedTtlAndNotifyUsers) {
    delete replaceInstances.blocked_ttl_minutes;
    delete replaceInstances.notify_users;
    delete replaceInstances.instance_block_user_message;
  }

  try {
    yield api.post({
      url: endpoints.setPublicationSchedule(id),
      data: {
        ...values,
        notification_emails: emailsList,
        replace_instances: replaceInstances,
      },
    });

    return yield all([
      put(setPublicationScheduleFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('PUBLICATION_SCHEDULE_SUCCESSFULLY_KEY'),
        })
      ),
      put(getPublicationScheduleRequest({ id, query })),
    ]);
  } catch (error) {
    return yield put(setPublicationScheduleRejected());
  }
}

function* cancelPublicationScheduleRequestSaga({ payload }) {
  const { id, query, scheduleUuid } = payload;
  try {
    yield api.post({
      url: endpoints.cancelPublicationSchedule(id, scheduleUuid),
    });

    return yield all([
      put(cancelPublicationScheduleFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('PUBLICATION_SCHEDULE_CANCEL_SUCCESSFULLY_KEY'),
        })
      ),
      put(getPublicationScheduleRequest({ id, query })),
    ]);
  } catch (error) {
    return yield put(cancelPublicationScheduleRejected());
  }
}

function* getBulkClientsRequestSaga({ payload }) {
  const { id, query } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getBulkClients(id, query),
    });

    return yield put(getBulkClientsFulfilled(data));
  } catch (error) {
    return yield put(getBulkClientsRejected());
  }
}

function* editBulkClientsRequestSaga({ payload }) {
  const { id, dataValues, isLimitLicenses } = payload;

  const query = {
    offset: 0,
    limit: 10,
    search: '',
  };
  try {
    const { data } = yield api.patch({
      url: endpoints.editBulkClients(id),
      data: dataValues,
    });

    yield put(editBulkClientsFulfilled(data));

    if (dataValues.operator_data.restricted_action_code) {
      yield all([
        put(
          messagesRequest({
            type: 'success',
            message: i18n.t('BULK_CLIENTS.EDIT_SUCCESSFULLY_KEY'),
          })
        ),
        put(!isLimitLicenses && modalClose()),
        put(getBulkClientsRequest({ id, query })),
      ]);
    }
  } catch (error) {
    yield put(editBulkClientsRejected());
  }
}

function* setProductionEnvironmentRequestSaga({ payload }) {
  const { id, status } = payload;

  try {
    yield api.patch({
      url: endpoints.editEnvironment(id),
      data: status,
    });

    return yield all([
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('BULK_CLIENTS.EDIT_SUCCESSFULLY_KEY'),
        })
      ),
      put(getEnvironmentRequest({ id, skipProvider: true })),
      put(editEnvironmentsFulfilled()),
    ]);
  } catch (error) {
    return yield put(editEnvironmentsRejected());
  }
}

function* acceptStatusPendingRequestSaga({ payload }) {
  const { id, accept } = payload;
  try {
    const { data } = yield api.post({
      url: endpoints.acceptStatusPending(id),
      data: { accept },
    });

    return yield all([
      put(acceptStatusPendingFulfilled(data)),
      put(getEnvironmentRequest({ id, skipProvider: true })),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('APPROVED_REQUEST_KEY'),
        })
      ),
    ]);
  } catch (error) {
    return yield put(acceptStatusPendingRejected());
  }
}

function* getBehaviorReportRequestSaga({ payload }) {
  const { filters } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getBehaviorReport(filters),
    });

    return yield put(getBehaviorReportFulfilled(data));
  } catch (error) {
    return yield put(getBehaviorReportRejected());
  }
}

function* getDNSReportRequestSaga({ payload }) {
  const { filters } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getDNSReport(filters),
    });

    return yield put(getDNSReportFulfilled(data));
  } catch (error) {
    return yield put(getDNSReportRejected());
  }
}

function* getMaintenanceReportRequestSaga({ payload }) {
  const { filters } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getMaintenanceReport(filters),
    });

    return yield put(getMaintenanceReportFulfilled(data));
  } catch (error) {
    return yield put(getMaintenanceReportRejected());
  }
}

function* getProductReportRequestSaga({ payload }) {
  const { filters } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getProductReport(filters),
    });

    return yield put(getProductReportFulfilled(data));
  } catch (error) {
    return yield put(getProductReportRejected());
  }
}

function* getProductTypeReportRequestSaga({ payload }) {
  const { filters } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getProductTypeReport(filters),
    });

    return yield put(getProductTypeReportFulfilled(data));
  } catch (error) {
    return yield put(getProductTypeReportRejected());
  }
}

function* getProviderReportRequestSaga({ payload }) {
  const { filters } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getProviderReport(filters),
    });

    return yield put(getProviderReportFulfilled(data));
  } catch (error) {
    return yield put(getProviderReportRejected());
  }
}

function* getRegionReportRequestSaga({ payload }) {
  const { filters } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getRegionReport(filters),
    });

    return yield put(getRegionReportFulfilled(data));
  } catch (error) {
    return yield put(getRegionReportRejected());
  }
}

function* getStatusReportRequestSaga({ payload }) {
  const { filters } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getStatusReport(filters),
    });

    return yield put(getStatusReportFulfilled(data));
  } catch (error) {
    return yield put(getStatusReportRejected());
  }
}

function* getVirtualizerReportRequestSaga({ payload }) {
  const { filters } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getVirtualizerReport(filters),
    });

    return yield put(getVirtualizerReportFulfilled(data));
  } catch (error) {
    return yield put(getVirtualizerReportRejected());
  }
}

function* getZeroTrustReportRequestSaga({ payload }) {
  const { filters } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getZeroTrustReport(filters),
    });

    return yield put(getZeroTrustReportFulfilled(data));
  } catch (error) {
    return yield put(getZeroTrustReportRejected());
  }
}

function* getTimezonesRequestSaga() {
  try {
    const { data } = yield api.get({
      url: endpoints.getTimezones(),
    });

    return yield put(getTimezonesFulfilled(data));
  } catch (error) {
    return yield put(getTimezonesRejected());
  }
}

function* extendCompletionDateRequestSaga({ payload }) {
  const { id, completion_date_proposed, completion_date_reason } = payload;

  try {
    yield api.put({
      url: endpoints.extendCompletionDate(id),
      data: { completion_date_proposed, completion_date_reason },
    });

    return yield all([
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('COMPLETION_DATE_EXTEND_REQUESTED_SUCCESSFULLY_KEY'),
        })
      ),
      put(getEnvironmentRequest({ id, skipProvider: true })),
      put(extendCompletionDateFulfilled()),
    ]);
  } catch (error) {
    return yield put(extendCompletionDateRejected());
  }
}

function* exportEnvironmentSummaryRequestSaga({ payload }) {
  const { query } = payload;

  query.language = i18n.language || 'pt-BR';
  try {
    const { data } = yield api.get({
      url: endpoints.exportEnvironmentSummary(query),
    });

    const elm = document.createElement('a');
    elm.href = `data:text/csv;charset=utf-8,${encodeURIComponent(data)}`;
    elm.target = '_blank';
    elm.download = `${i18n.t('ENVIRONMENTS_KEY')}-${new Date().toLocaleString(
      'pt-BR',
      {
        hour12: false,
      }
    )}-summary.csv`;

    elm.click();

    return yield all([
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('EXPORT_CSV_SUCCESS_KEY'),
        })
      ),
      put(exportEnvironmentSummaryFulfilled(data)),
    ]);
  } catch (error) {
    return yield put(exportEnvironmentSummaryRejected());
  }
}

function* validateZeroTrustRequestSaga({ payload }) {
  const { environmentUuid, instanceUuid } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.validateZeroTrust(environmentUuid, instanceUuid),
    });

    return yield put(validateZeroTrustFulfilled(data));
  } catch (error) {
    return yield put(validateZeroTrustRejected());
  }
}

function* publishImageRequestSaga({ payload }) {
  const { environmentUuid, instanceId, values } = payload;

  const emailsList: string[] = values?.notify_list.split(',').filter(Boolean);

  const replaceInstancesIn = values?.replace_instances || {};
  const replaceInstances = { ...replaceInstancesIn };

  if (!replaceInstances.notify_users) {
    delete replaceInstances.instance_block_user_message;
  }

  const allowBlockedTtlAndNotifyUsers =
    replaceInstances.block_instances === true;

  if (!allowBlockedTtlAndNotifyUsers) {
    delete replaceInstances.blocked_ttl_minutes;
    delete replaceInstances.notify_users;
    delete replaceInstances.instance_block_user_message;
  }

  try {
    yield api.post({
      url: endpoints.publishImage(environmentUuid, instanceId),
      data: {
        ...values,
        notify_list: emailsList,
        replace_instances: replaceInstances,
      },
    });
    return yield all([
      put(publishImageFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('PUBLISHING_STARTED_SUCCESSFULLY_KEY'),
        })
      ),
      put(getPublishHistoryRequest({ environmentUuid })),
    ]);
  } catch (error) {
    return yield put(publishImageRejected());
  }
}

function* getPublishHistoryRequestSaga({ payload }) {
  const { environmentUuid } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getPublishHistory(environmentUuid),
    });
    return yield put(getPublishHistoryFulfilled(data));
  } catch (error) {
    return yield put(getPublishHistoryRejected());
  }
}

function* exportHistoryMonitoringCSVRequestSaga({ payload }) {
  const { id, filename } = payload;

  try {
    const { data } = yield api.get({
      url: endpoints.exportHistoryMonitoringCSV(id),
    });

    const elm = document.createElement('a');
    elm.href = `data:text/csv;charset=utf-8,${encodeURI(data)}`;
    elm.target = '_blank';
    elm.download = `${filename}.csv`;

    elm.click();

    return yield all([
      put(exportHistoryMonitoringCSVFulfilled()),
      messagesRequest({
        type: 'success',
        message: i18n.t('EXPORT_CSV_SUCCESS_KEY'),
      }),
    ]);
  } catch (error) {
    return yield put(exportHistoryMonitoringCSVRejected());
  }
}
function* blockServerActionsRequestSaga({ payload }) {
  const { environmentUuid, instanceId, values } = payload;
  try {
    yield api.post({
      url: endpoints.blockServerActions(environmentUuid, instanceId),
      data: values,
    });

    return yield all([
      put(blockServerActionsFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('BLOCK_SERVER_ACTIONS_SUCCESSFULLY_KEY'),
        })
      ),
      put(getPreparationServerRequest({ id: environmentUuid })),
    ]);
  } catch (error) {
    return yield put(blockServerActionsRejected());
  }
}
function* getEnvironmentSessionsRequestSaga({ payload }) {
  const { environmentUuid, query } = payload;

  try {
    const { data } = yield api.get({
      url: endpoints.getEnvironmentSessions(environmentUuid, query),
    });

    return yield put(getEnvironmentSessionsFulfilled(data));
  } catch (error) {
    return yield put(getEnvironmentSessionsRejected());
  }
}

function* unblockServerActionsRequestSaga({ payload }) {
  const { environmentUuid, instanceId, values } = payload;
  try {
    yield api.post({
      url: endpoints.unblockServerActions(environmentUuid, instanceId),
      data: values,
    });

    return yield all([
      put(unblockServerActionsFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('UNBLOCK_SERVER_ACTIONS_SUCCESSFULLY_KEY'),
        })
      ),
      put(getPreparationServerRequest({ id: environmentUuid })),
    ]);
  } catch (error) {
    return yield put(unblockServerActionsRejected());
  }
}

function* getLicenseGroupsRequestSaga({ payload }) {
  const { environmentUuid, query } = payload;

  try {
    const { data } = yield api.get({
      url: endpoints.getLicenseGroups(environmentUuid, query),
    });

    return yield put(getLicenseGroupsFulfilled(data));
  } catch (error) {
    return yield put(getLicenseGroupsRejected());
  }
}

function* createLicenseGroupRequestSaga({ payload }) {
  const { environmentUuid, values, handleOpenAddClientsModal, query } = payload;

  try {
    const { data } = yield api.post({
      url: endpoints.createLicenseGroup(environmentUuid),
      data: values,
    });

    return yield all([
      put(createLicenseGroupFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('GROUP_CREATED_SUCCESSFULLY_KEY'),
        })
      ),
      put(handleOpenAddClientsModal(data.uuid)),
      put(
        getLicenseGroupsRequest({
          environmentUuid,
          query,
        })
      ),
    ]);
  } catch (error) {
    return yield put(createLicenseGroupRejected());
  }
}

function* getLicenseGroupDetailsRequestSaga({ payload }) {
  const { environmentUuid, licenseGroupUuid } = payload;

  try {
    const { data } = yield api.get({
      url: endpoints.getLicenseGroupDetails(environmentUuid, licenseGroupUuid),
    });

    return yield put(getLicenseGroupDetailsFulfilled(data));
  } catch (error) {
    return yield put(getLicenseGroupDetailsRejected());
  }
}

function* editLicenseGroupRequestSaga({ payload }) {
  const { environmentUuid, licenseGroupUuid, values, query } = payload;

  try {
    yield api.patch({
      url: endpoints.editLicenseGroup(environmentUuid, licenseGroupUuid),
      data: values,
    });

    return yield all([
      put(editLicenseGroupFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('GROUP_UPDATED_SUCCESSFULLY_KEY'),
        })
      ),
      put(
        getLicenseGroupsRequest({
          environmentUuid,
          query,
        })
      ),
    ]);
  } catch (error) {
    return yield put(editLicenseGroupRejected());
  }
}

function* deleteLicenseGroupRequestSaga({ payload }) {
  const { environmentUuid, licenseGroupUuid, query } = payload;

  try {
    yield api.delete({
      url: endpoints.deleteLicenseGroup(environmentUuid, licenseGroupUuid),
    });

    return yield all([
      put(deleteLicenseGroupFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('GROUP_DELETED_SUCCESSFULLY_KEY'),
        })
      ),
      put(
        getLicenseGroupsRequest({
          environmentUuid,
          query,
        })
      ),
    ]);
  } catch (error) {
    return yield put(deleteLicenseGroupRejected());
  }
}
function* addClientsToLicenseGroupRequestSaga({ payload }) {
  const { environmentUuid, licenseGroupUuid, cli_uuids, query } = payload;

  try {
    yield api.post({
      url: endpoints.addClientsToLicenseGroup(
        environmentUuid,
        licenseGroupUuid
      ),
      data: { clients_uuid: cli_uuids },
    });

    return yield all([
      put(addClientsToLicenseGroupFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('CLIENTS_ADDED_SUCCESSFULLY_KEY'),
        })
      ),
      put(
        getLicenseGroupsRequest({
          environmentUuid,
          query,
        })
      ),
    ]);
  } catch (error) {
    return yield put(addClientsToLicenseGroupRejected());
  }
}

function* fullUpdateLicenseGroupClientsRequestSaga({ payload }) {
  const { environmentUuid, licenseGroupUuid, cli_uuids, query } = payload;

  try {
    yield api.post({
      url: endpoints.fullUpdateLicenseGroupClients(
        environmentUuid,
        licenseGroupUuid
      ),
      data: { clients_uuid: cli_uuids },
    });

    return yield all([
      put(fullUpdateLicenseGroupClientsFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('CLIENTS_UPDATED_SUCCESSFULLY_KEY'),
        })
      ),
      put(
        getLicenseGroupsRequest({
          environmentUuid,
          query,
        })
      ),
    ]);
  } catch (error) {
    return yield put(fullUpdateLicenseGroupClientsRejected());
  }
}

function* removeClientsApplicationsPlatformRequestSaga({ payload }) {
  const { id, code, query } = payload;
  try {
    const { data } = yield api.post({
      url: endpoints.removeClientsApplicationsPlatform(id),
      data: { code },
    });

    return yield all([
      put(removeClientsApplicationsPlatformFulfilled(data)),
      put(getAllApplicationsPlatformRequest({ id, query })),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('REMOVE_APP_SUCCESSFULLY_KEY'),
        })
      ),
    ]);
  } catch (error) {
    return yield put(removeClientsApplicationsPlatformRejected());
  }
}

function* getConnectionTypeEnvironmentReportRequestSaga({ payload }) {
  const { filters } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getConnectionTypeEnvironmentReport(filters),
    });

    return yield put(getConnectionTypeEnvironmentReportFulfilled(data));
  } catch (error) {
    return yield put(getConnectionTypeEnvironmentReportRejected());
  }
}

function* getEnvironmentAdvisorsRequestSaga({ payload }) {
  const { environmentUuid, query } = payload;

  try {
    const { data } = yield api.get({
      url: endpoints.getEnvironmentAdvisors(environmentUuid, query),
    });

    return yield put(getEnvironmentAdvisorsFulfilled(data));
  } catch (error) {
    return yield put(getEnvironmentAdvisorsRejected(error));
  }
}

function* getAdminPinRequestSaga({ payload }) {
  const { environmentUuid } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getAdminPin(environmentUuid),
    });
    return yield all([put(getAdminPinFulfilled(data))]);
  } catch (error) {
    return yield put(getAdminPinRejected());
  }
}

function* resetAdminPinRequestSaga({ payload }) {
  const { environmentUuid } = payload;

  try {
    yield api.patch({
      url: endpoints.resetAdminPin(environmentUuid),
    });

    return yield all([
      put(resetAdminPinFulfilled()),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t('PIN_RESET_KEY'),
        })
      ),
      put(getEnvironmentRequest({ id: environmentUuid, skipProvider: true })),
      put(getAdminPinRequest({ environmentUuid })),
    ]);
  } catch (error) {
    return yield put(resetAdminPinRejected());
  }
}

function* enableServerMonitoringManagementRequestSaga({ payload }) {
  const { environmentUuid, serverId, type, query } = payload;

  try {
    yield api.patch({
      url: endpoints.enableServerMonitoringManagement(
        environmentUuid,
        serverId
      ),
    });
    return yield all([
      put(enableServerMonitoringManagementFulfilled({ type })),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t(
            'ENABLE_SERVER_MONITORING_MANAGEMENT_SUCCESSFULLY_KEY'
          ),
        })
      ),
      put(getAllServersRequest({ id: environmentUuid, type, query })),
    ]);
  } catch (error) {
    return yield put(enableServerMonitoringManagementRejected(type));
  }
}

function* disableServerMonitoringManagementRequestSaga({ payload }) {
  const { environmentUuid, serverId, type, query } = payload;

  try {
    yield api.patch({
      url: endpoints.disableServerMonitoringManagement(
        environmentUuid,
        serverId
      ),
    });
    return yield all([
      put(disableServerMonitoringManagementFulfilled({ type })),
      put(
        messagesRequest({
          type: 'success',
          message: i18n.t(
            'DISABLE_SERVER_MONITORING_MANAGEMENT_SUCCESSFULLY_KEY'
          ),
        })
      ),
      put(getAllServersRequest({ id: environmentUuid, type, query })),
    ]);
  } catch (error) {
    return yield put(disableServerMonitoringManagementRejected(type));
  }
}

function* getAllServersMonitoringStatusRequestSaga({ payload }) {
  const { environment_uuid, servers } = payload;

  const { permissions } = yield select(state => ({
    permissions: state.authenticate.data.permissions,
  }));

  if (!permissions?.can_view_server_monitoring_status) return;

  yield all(
    servers.map(
      server =>
        server.monitoring_management_enabled &&
        put(
          getServerMonitoringStatusRequest({
            environment_uuid,
            serverId: server.instance_id,
          })
        )
    )
  );
}

function* getServerMonitoringStatusRequestSaga({ payload }) {
  const { environment_uuid, serverId } = payload;

  try {
    const { data } = yield api.get({
      url: endpoints.getServerMonitoringStatus(environment_uuid, serverId),
    });

    return yield put(getServerMonitoringStatusFulfilled({ serverId, data }));
  } catch (error) {
    return yield put(getServerMonitoringStatusRejected({ serverId }));
  }
}

export default all([
  takeLatest(newEnvironmentRequest, newEnvironmentRequestSaga),
  takeLatest(getAllEnvironmentsRequest, getAllEnvironmentsRequestSaga),
  takeLatest(getEnvironmentRequest, getEnvironmentRequestSaga),
  takeLatest(getAllInstancesRequest, getAllInstancesRequestSaga),
  takeLatest(getPreparationServerRequest, getPreparationServerRequestSaga),
  takeLatest(getSupportServerRequest, getSupportServersRequestSaga),
  takeLatest(getAllServersRequest, getAllServersRequestSaga),
  takeLatest(getAllModelsRequest, getAllModelsRequestSaga),
  takeLatest(registerModelRequest, registerModelRequestSaga),
  takeLatest(editModelRequest, editModelRequestSaga),
  takeLatest(getModelRequest, getModelRequestSaga),
  takeLatest(removeModelRequest, removeModelRequestSaga),
  takeLatest(getSecurityStateRequest, getSecurityStateSaga),
  takeLatest(editSecurityRequest, editSecurityRequestSaga),
  takeLatest(terminateInstanceRequest, terminateInstanceRequestSaga),
  takeLatest(rebootInstanceRequest, rebootInstanceRequestSaga),
  takeLatest(toggleBlockInstancesRequest, toggleBlockInstancesRequestSaga),
  takeLatest(removeInstanceRequest, removeInstanceRequestSaga),
  takeLatest(
    getAllSessionsInInstanceRequest,
    getAllSessionsInInstanceRequestSaga
  ),
  takeLatest(
    getInstanceObservabilityRequest,
    getInstanceObservabilityRequestSaga
  ),
  takeLatest(removeSessionsInstanceRequest, removeSessionsInstanceRequestSaga),
  takeLatest(registerNewInstanceRequest, registerNewInstanceRequestSaga),
  takeLatest(attachServerRequest, attachServerRequestSaga),
  takeLatest(detachServerRequest, detachServerRequestSaga),
  takeLatest(unlinkInstanceRequest, unlinkInstanceRequestSaga),
  takeLatest(activateInstanceRequest, activateInstanceRequestSaga),
  takeLatest(getEnvironmentBehaviorRequest, getEnvironmentBehaviorRequestSaga),
  takeLatest(
    editEnvironmentBehaviorRequest,
    editEnvironmentBehaviorRequestSaga
  ),
  takeLatest(getProviderResourcesRequest, getProviderResourcesRequestSaga),
  takeLatest(getAwsResourcesRequest, getAwsResourcesRequestSaga),
  takeLatest(getOciResourcesRequest, getOciResourcesRequestSaga),
  takeLatest(getBootVolumesRequest, getBootVolumesRequestSaga),
  takeLatest(getBootVolumeBackupsRequest, getBootVolumeBackupsRequestSaga),
  takeLatest(getSecurityGroupsRequest, getSecurityGroupsRequestSaga),
  takeLatest(getZonesRequest, getZonesRequestSaga),
  takeLatest(getSubnetsRequest, getSubnetsRequestSaga),
  takeLatest(getKeyPairsRequest, getKeyPairsRequestSaga),
  takeLatest(getImagesRequest, getImagesRequestSaga),
  takeLatest(
    getListProviderResourcesRequest,
    getListProviderResourcesRequestSaga
  ),
  takeLatest(getFlavorsRequest, getFlavorsRequestSaga),
  takeLatest(editEnvironmentsRequest, editEnvironmentsRequestSaga),
  takeLatest(
    getUrlsEnvironmentsDashboardRequest,
    getUrlsEnvironmentsDashboardRequestSaga
  ),
  takeLatest(
    getSessionsChartDashboardRequest,
    getSessionsChartDashboardRequestSaga
  ),
  takeLatest(
    getInstanceChartDashboardRequest,
    getInstanceChartDashboardRequestSaga
  ),

  takeLatest(getMaintenanceRequest, getMaintenanceRequestSaga),
  takeLatest(startServerRequest, startServerRequestSaga),
  takeLatest(stopServerRequest, stopServerRequestSaga),
  takeLatest(restartServerRequest, restartServerRequestSaga),
  takeLatest(removeEnvironmentRequest, removeEnvironmentRequestsSaga),
  takeLatest(publishNewImageRequest, publishNewImageRequestSaga),
  takeLatest(getAllImagesLogsRequest, getAllImagesLogsRequestSaga),
  takeLatest(duplicateModelRequest, duplicateModelRequestSaga),
  takeLatest(stopTimeRequest, stopTimeRequestSaga),
  takeLatest(
    editMaintenanceEnvironmentsRequest,
    editMaintenanceEnvironmentsRequestSaga
  ),
  takeLatest(connectAsRequest, connectAsRequestSaga),
  takeLatest(getAlarmsInstanceRequest, getAlarmsInstanceRequestSaga),
  takeLatest(removeMultipleModelsRequest, removeMultipleModelsRequestSaga),
  takeLatest(
    terminateMultipleInstancesRequest,
    terminateMultipleInstancesRequestSaga
  ),
  takeLatest(
    toggleBlockMultipleInstancesRequest,
    toggleBlockMultipleInstancesRequestSaga
  ),
  takeLatest(
    getAllEnvironmentsOperatorRequest,
    getAllEnvironmentsOperatorRequestSaga
  ),
  takeLatest(
    getDashboardSessionsGraphRequest,
    getDashboardSessionsGraphRequestSaga
  ),
  takeLatest(
    getDashboardEnvironmentCostGraphRequest,
    getDashboardEnvironmentCostGraphRequestSaga
  ),
  takeLatest(getFlavorsCostRequest, getFlavorsCostRequestSaga),
  takeLatest(
    getAllApplicationsAutoskyRequest,
    getAllApplicationsAutoskyRequestSaga
  ),
  takeLatest(
    getClientsApplicationsAutoskyRequest,
    getClientsApplicationsAutoskyRequestSaga
  ),
  takeLatest(
    renameClientsApplicationsAutoskyRequest,
    renameClientsApplicationsAutoskyRequestSaga
  ),
  takeLatest(
    removeClientsApplicationsAutoskyRequest,
    removeClientsApplicationsAutoskyRequestSaga
  ),
  takeLatest(
    changeStateClientsApplicationsAutoskyRequest,
    changeStateClientsApplicationsAutoskyRequestSaga
  ),
  takeLatest(
    includeClientsApplicationsAutoskyRequest,
    includeClientsApplicationsAutoskyRequestSaga
  ),
  takeLatest(
    getClientsToIncludeApplicationsAutoskyRequest,
    getClientsToIncludeApplicationsAutoskyRequestSaga
  ),
  takeLatest(
    getAllApplicationsPlatformRequest,
    getAllApplicationsPlatformRequestSaga
  ),
  takeLatest(
    getClientsApplicationsPlatformRequest,
    getClientsApplicationsPlatformRequestSaga
  ),
  takeLatest(
    removeClientsApplicationsPlatformRequest,
    removeClientsApplicationsPlatformRequestSaga
  ),
  takeLatest(migrateEnvironmentRequest, migrateEnvironmentRequestSaga),
  takeLatest(
    getEnvironmentPerformanceCPURequest,
    getEnvironmentPerformanceCPURequestSaga
  ),
  takeLatest(
    getEnvironmentPerformanceMemoryRequest,
    getEnvironmentPerformanceMemoryRequestSaga
  ),
  takeLatest(
    getEnvironmentMonitoringRequest,
    getEnvironmentMonitoringRequestSaga
  ),
  takeLatest(
    editEnvironmentMonitoringRequest,
    editEnvironmentMonitoringRequestSaga
  ),
  takeLatest(getMonitoringHistoryRequest, getMonitoringHistoryRequestSaga),
  takeLatest(
    getEnvironmentPerformanceOperationalTimeRequest,
    getEnvironmentPerformanceOperationalTimeRequestSaga
  ),
  takeLatest(getPublicationScheduleRequest, getPublicationScheduleRequestSaga),
  takeLatest(setPublicationScheduleRequest, setPublicationScheduleRequestSaga),
  takeLatest(
    cancelPublicationScheduleRequest,
    cancelPublicationScheduleRequestSaga
  ),
  takeLatest(getBulkClientsRequest, getBulkClientsRequestSaga),
  takeLatest(editBulkClientsRequest, editBulkClientsRequestSaga),
  takeLatest(
    setProductionEnvironmentRequest,
    setProductionEnvironmentRequestSaga
  ),
  takeLatest(acceptStatusPendingRequest, acceptStatusPendingRequestSaga),
  takeLatest(getTimezonesRequest, getTimezonesRequestSaga),
  takeLatest(extendCompletionDateRequest, extendCompletionDateRequestSaga),
  takeLatest(getBehaviorReportRequest, getBehaviorReportRequestSaga),
  takeLatest(getDNSReportRequest, getDNSReportRequestSaga),
  takeLatest(getMaintenanceReportRequest, getMaintenanceReportRequestSaga),
  takeLatest(getProductReportRequest, getProductReportRequestSaga),
  takeLatest(getProductTypeReportRequest, getProductTypeReportRequestSaga),
  takeLatest(getProviderReportRequest, getProviderReportRequestSaga),
  takeLatest(getRegionReportRequest, getRegionReportRequestSaga),
  takeLatest(getStatusReportRequest, getStatusReportRequestSaga),
  takeLatest(getVirtualizerReportRequest, getVirtualizerReportRequestSaga),
  takeLatest(getZeroTrustReportRequest, getZeroTrustReportRequestSaga),
  takeLatest(
    exportEnvironmentSummaryRequest,
    exportEnvironmentSummaryRequestSaga
  ),
  takeLatest(validateZeroTrustRequest, validateZeroTrustRequestSaga),
  takeLatest(publishImageRequest, publishImageRequestSaga),
  takeLatest(getPublishHistoryRequest, getPublishHistoryRequestSaga),
  takeLatest(
    exportHistoryMonitoringCSVRequest,
    exportHistoryMonitoringCSVRequestSaga
  ),
  takeLatest(getEnvironmentSessionsRequest, getEnvironmentSessionsRequestSaga),
  takeLatest(blockServerActionsRequest, blockServerActionsRequestSaga),
  takeLatest(unblockServerActionsRequest, unblockServerActionsRequestSaga),
  takeLatest(getLicenseGroupsRequest, getLicenseGroupsRequestSaga),
  takeLatest(createLicenseGroupRequest, createLicenseGroupRequestSaga),
  takeLatest(getLicenseGroupDetailsRequest, getLicenseGroupDetailsRequestSaga),
  takeLatest(editLicenseGroupRequest, editLicenseGroupRequestSaga),
  takeLatest(deleteLicenseGroupRequest, deleteLicenseGroupRequestSaga),
  takeLatest(
    addClientsToLicenseGroupRequest,
    addClientsToLicenseGroupRequestSaga
  ),
  takeLatest(
    fullUpdateLicenseGroupClientsRequest,
    fullUpdateLicenseGroupClientsRequestSaga
  ),
  takeLatest(
    getConnectionTypeEnvironmentReportRequest,
    getConnectionTypeEnvironmentReportRequestSaga
  ),
  takeLatest(getEnvironmentAdvisorsRequest, getEnvironmentAdvisorsRequestSaga),
  takeLatest(getAdminPinRequest, getAdminPinRequestSaga),
  takeLatest(resetAdminPinRequest, resetAdminPinRequestSaga),
  takeLatest(
    enableServerMonitoringManagementRequest,
    enableServerMonitoringManagementRequestSaga
  ),
  takeLatest(
    disableServerMonitoringManagementRequest,
    disableServerMonitoringManagementRequestSaga
  ),
  takeLatest(
    getAllServersMonitoringStatusRequest,
    getAllServersMonitoringStatusRequestSaga
  ),
  takeEvery(
    getServerMonitoringStatusRequest,
    getServerMonitoringStatusRequestSaga
  ),
]);
